import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=4e1ff181&scoped=true&"
import script from "./CategoryGrid.vue?vue&type=script&lang=js&"
export * from "./CategoryGrid.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGrid.vue?vue&type=style&index=0&id=4e1ff181&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ff181",
  null
  
)

export default component.exports